

import { useEffect, useState } from "react";
import Drawer from "../../component/global/drawer";
import { addData } from "../../config/data";
import Swal from "sweetalert2";
import ViewConfig from "../../config/viewConfig";
import '../../index.css';
import Lang from "../../config/lang";
import { useSelector } from "react-redux";
import { useDrawerTransition } from "../../context/drawerProvider";
import { setSession } from "../../config/helper";

const JobDrawer = ({ title = 'Menu', job = {}, isOpen, setIsDrawerOpen }) => {
    const { startTransition } = useDrawerTransition();
    const { lang } = useSelector((state) => state.globalReducer);
    const mobileView = ViewConfig();
    const [candName, setCandName] = useState('');
    const [canEmail, setCanEmail] = useState('');
    const [canPhoneNumber, setCanPhoneNumber] = useState('');
    const [password, setpassword] = useState('');
    const [confirmpassword, setconfirmpassword] = useState('');
    const [showPassword, setshowPassword] = useState(null);
    const [showConfirmPassword, setshowConfirmPassword] = useState(null);
    const [isLoading, setisLoading] = useState(false);
    const [isSending, setisSending] = useState(false);
    const [isVerify, setisVerify] = useState(false);
    const [isVerified, setisVerified] = useState(false);
    const [otp, setOtp] = useState(Array(4).fill(""));
    const [errors, setErrors] = useState({});
    const [counter, setCounter] = useState(0);

    useEffect(() => {
        let timer;
        if (counter > 0) {
            timer = setInterval(() => {
                setCounter((prev) => prev - 1);
            }, 1000);
        }
        return () => clearInterval(timer);
    }, [counter]);

    useEffect(() => {
        setOtp(Array(4).fill(""))
        setisVerify(false)
    }, [])


    const handleSubmit = () => {
        try {

            const newErrors = {};

            if (!candName) newErrors.candName = "full_name_required";
            if (!canPhoneNumber) newErrors.canPhoneNumber = "phone_number_required";
            if (canPhoneNumber) {
                if (canPhoneNumber.charAt(0) === '0' || canPhoneNumber.includes('+') || canPhoneNumber.includes('-') || canPhoneNumber.includes(',') || canPhoneNumber.toLowerCase().includes('e') || canPhoneNumber.charAt(0) === '+62' || canPhoneNumber.charAt(0) === '628') {
                    newErrors.canPhoneNumber = "phone_number_format_wrong"
                }
            }
            if (!otp) newErrors.canEmail = 'please_fill_your_otp'
            if (!isVerify && !isVerified) newErrors.canEmail = 'please_verify_your_email'
            if (canEmail) {
                const isValid = isValidEmail(canEmail);
                if (!isValid) {
                    newErrors.canEmail = 'invalid_email_format';
                }
            }
            if (!isVerified) newErrors.otp = 'please_verify_your_email';
            if (!canEmail) newErrors.canEmail = "email_required";
            if (!password) newErrors.password = "password_required";
            if (password.length < 6) newErrors.password = "password_length";
            if (!confirmpassword) newErrors.confirmpassword = 'password_required';
            if (confirmpassword && password && confirmpassword !== password) {
                newErrors.confirmpassword = 'password_not_match';
            }
            setErrors(newErrors);

            if (Object.keys(newErrors).length === 0) {
                setisSending(true);

                submitApplication()
            }
        } catch (error) {
            setisSending(false);
            console.log('error:', error)
        }
    };

    function isValidEmail(email) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }

    const showAlert = () => {
        Swal.fire({
            title: 'Success!',
            text: Lang(lang, 'apply_job_success'),
            icon: 'success',
            timer: 3000,
            showConfirmButton: false,
            customClass: {
                popup: 'my-custom-popup'
            }
        });
    };


    const showError = (error) => {
        Swal.fire({
            title: 'Error!',
            text: error || Lang(lang, 'apply_job_failed'),
            icon: 'error',
            timer: 3000,
            showConfirmButton: false,
            customClass: {
                popup: 'my-custom-popup'
            }
        });
    };


    const verifyOTP = async (email, otp) => {
        setisLoading(true)

        const payload = {
            email: email,
            otpCode: otp,
        };
        console.log(payload)
        const newErrors = errors;

        try {

            const response = await addData({
                url: 'Candidates/VerifyOTP',
                reqBody: payload
            });
            console.log(response)

            if (String(response).includes('Invalid')) {
                newErrors.otp = 'invalid_otp'
                setErrors(newErrors);
                setisVerified(false)
                setisLoading(false)
            } else {
                if (response) {
                    const message = response.message;
                    if (message) {
                        if (message.includes('Email verified successfully')) {
                            newErrors.otp = ''
                            setErrors(newErrors);
                            setisLoading(false);
                            setisVerified(true);
                        }
                    }
                } else {
                    newErrors.otp = response || 'invalid_otp';
                    setErrors(newErrors);
                    setisVerified(false);
                    setisLoading(false);
                }
            }
        } catch (error) {
            newErrors.otp = error;
            setErrors(newErrors);
            setisVerified(false);
            setisLoading(false);
        }
    }
    const sendOTP = async (name, email, companyID) => {
        const newErrors = errors;
        const isValid = isValidEmail(canEmail);
        if (!isValid) {
            newErrors.canEmail = 'invalid_email_format';
            setErrors(newErrors)
        } else {
            const payload = {
                name: name,
                email: email,
                companyID: companyID,
            };
            try {
                const response = await addData({
                    url: 'Candidates/SendEmailAndGenerateOTP',
                    reqBody: payload
                });
                if (`${response}`.includes('Account found')) {
                    const newErrors = {};
                    newErrors.canEmail = 'emailregistered';
                    setErrors(newErrors);
                } else {
                    setisVerify(true)
                    if (!candName) newErrors.candName = "full_name_required";
                    if (!canPhoneNumber) newErrors.canPhoneNumber = "phone_number_required";
                    if (canPhoneNumber) {
                        if (canPhoneNumber.charAt(0) === '0' || canPhoneNumber.includes('+') || canPhoneNumber.includes('-') || canPhoneNumber.includes(',') || canPhoneNumber.toLowerCase().includes('e') || canPhoneNumber.charAt(0) === '+62' || canPhoneNumber.charAt(0) === '628') {
                            newErrors.canPhoneNumber = "phone_number_format_wrong"
                        }
                    }
                    if (!otp) newErrors.canEmail = 'please_fill_your_otp'
                    if (!canEmail) newErrors.canEmail = "email_required";

                    setErrors(newErrors)
                }
            } catch (error) {
                const newErrors = errors;
                newErrors.canEmail = String(error);
                setErrors(newErrors)
            }
        }
    }



    const submitApplication = async () => {
        const candidateData = {
            candidateName: candName,
            email: canEmail,
            phoneNumber: `0${canPhoneNumber}`,
            resumeURL: '',
            remarks: '',
            jobID: job.jobID,
            status: 'Screening'
        };
        try {
            await addData({
                url: 'Candidates',
                params: candidateData,
            }).then(async res => {
                if (res?.data) {
                    const candRes = res?.data;

                    const applicantPayload = {
                        candidateID: candRes.candidateID,
                        fullName: candName,
                        email: canEmail,
                        mobilePhoneNumber: `0${canPhoneNumber}`,
                        resumeURL: '',
                        password: password
                    };
                    await addData({
                        url: 'Applicants',
                        reqBody: applicantPayload,
                    }).then(async res => {
                        if (res?.data) {
                            const applicantRes = res?.data;
                            await addData({
                                url: 'Auth/loginCandidate',
                                params: [
                                    { title: 'Email', value: canEmail },
                                    { title: 'Password', value: password },
                                ],
                            }).then(async loginRes => {
                                if (loginRes?.token) {
                                    setSession(
                                        applicantRes?.applicantID,
                                        applicantRes,
                                        180,
                                        loginRes?.token,
                                    );
                                    setIsDrawerOpen(false)
                                    setisSending(false);
                                    setTimeout(() => {
                                        setOtp(Array(4).fill(""))
                                        setisVerify(false)
                                        setisVerified(false);

                                        setCounter(0)
                                        showAlert()
                                    }, 500);
                                    setTimeout(() => {
                                        startTransition(`/${lang}/profile`);
                                    }, 3000);
                                } else {
                                    setisSending(false);
                                    showError(loginRes)
                                }
                            })
                        }
                    })
                } else {
                    // setIsDrawerOpen(false)
                    setisSending(false);
                    setCounter(0)
                    setTimeout(() => {
                        setisVerified(false);
                        setOtp(Array(4).fill(""))
                        setisVerify(false)
                        showError(res)
                    }, 500);
                }
            })
        } catch (error) {
            setisSending(false);
            setIsDrawerOpen(false)
            setisVerified(false);
            setTimeout(() => {
                setOtp(Array(4).fill(""))
                setisVerify(false)
                showError(error)
            }, 500);
        }
    }

    const handleChange = (value, index) => {
        if (/^[0-9]?$/.test(value)) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            // Auto focus ke next input
            if (value && index < otp.length - 1) {
                document.getElementById(`otp-${index + 1}`).focus();
            }
        }
    };

    return (<>
        <Drawer
            title={title}
            job={job}
            isOpen={isOpen}
            onClose={() => {
                setpassword('')
                setisSending(false)
                setisLoading(false)
                setCounter(0)
                setOtp(Array(4).fill(""))
                setisVerified(false);
                setisVerify(false)
                setCanEmail(null)
                setCandName(null)
                setCanPhoneNumber(null)
                setIsDrawerOpen(false)
                const newErrors = {};
                setErrors(newErrors);
            }}
            position={'right'}
            setWidth={mobileView ? "w-full" : "w-[690px]"}
            setStyle={{ backgroundImage: 'linear-gradient(160deg, #F1F5F9 50%, #7BB3F4 100%)' }}
        >
            <form className="mx-auto px-8 py-5 md:py-9">
                <div className="mb-6">
                    <label htmlFor="name" className="block mb-2 text-xs md:text-[17px] font-medium text-[#48494B]">{Lang(lang, 'full_name')}<b className='text-[#EA2427] font-semibold'>*</b></label>
                    <input type="text" id="name" className={`rounded-[35px] border job-form ${errors.candName ? "border-red-500" : "border-[#ffffff]"
                        } text-sm p-[16px] pl-[20px] w-full h-[60px]`} required onChange={(e) => {
                            setCandName(e.target.value)
                            if (Object.keys(errors).length !== 0) {
                                const newErrors = {};
                                if (!e.target.value) newErrors.candName = "full_name_required";
                                if (!canPhoneNumber) newErrors.canPhoneNumber = "phone_number_required";
                                if (!canEmail) newErrors.canEmail = "email_required";
                                setErrors(newErrors);
                            }
                        }} />
                    {errors.candName && <p className="text-red-500 text-xs mt-1">{Lang(lang, errors.candName)}</p>}
                </div>
                <div className="mb-6">
                    <label htmlFor="phone" className="block mb-2 text-xs md:text-[17px] font-medium text-[#48494B]">{Lang(lang, 'phone_number')}<b className='text-[#EA2427] font-semibold'>*</b></label>
                    <div className="flex flex-row rounded-l-[35px]">
                        <div className={`${errors.canPhoneNumber ? "border-red-500" : "border-[#48494B]"
                            } flex h-[60px] w-[60px] job-form items-center justify-center rounded-l-[35px]`} >
                            <p className="font-medium">{'+62'}</p>
                        </div>
                        <input type="number" id="phone" className={`rounded-r-[35px] job-form ${errors.canPhoneNumber ? "border-red-500" : "border-[#48494B]"
                            } text-sm p-[16px] pl-[20px] w-full h-[60px] appearance-none`} required onChange={(e) => {
                                setCanPhoneNumber(e.target.value)
                                if (Object.keys(errors).length !== 0) {
                                    const newErrors = {};
                                    if (!candName) newErrors.candName = "full_name_required";
                                    if (!e.target.value) newErrors.canPhoneNumber = "phone_number_required";
                                    if (!canEmail) newErrors.canEmail = "email_required";
                                    setErrors(newErrors);
                                }
                            }} />
                    </div>
                    {errors.canPhoneNumber && <p className="text-red-500 text-xs mt-1">{Lang(lang, errors.canPhoneNumber)}</p>}
                </div>
                <div className="mb-6">
                    <label htmlhtmlFor="email" className="block mb-2 text-xs md:text-[17px] font-medium text-[#48494B]">Email<b className='text-[#EA2427] font-normal'> ({Lang(lang, 'please_verify_before_continuing')})*</b> </label>

                    {isVerify && !isVerified && (
                        <div>
                            <p className="text-gray-500 text-sm">
                                {Lang(lang, 'we_sent_otp_to_email')} <br />
                                <span className="font-medium">{canEmail}</span>
                            </p>

                            <div className="flex justify-center md:justify-start items-center gap-3 mt-3 mb-5 md:mb-3 w-full flex-wrap">
                                {otp.map((digit, index) => (
                                    <input
                                        key={index}
                                        id={`otp-${index}`}
                                        type="text"
                                        maxLength="1"
                                        value={digit}
                                        onChange={(e) => {
                                            handleChange(e.target.value, index)
                                        }}
                                        className="w-[60px] h-[60px] text-center border rounded-lg text-xl focus:ring-2 focus:ring-blue-500 outline-none"
                                    />
                                ))}

                                {!isVerified && (
                                    <button
                                        className={`rounded-full ${(otp.join('')) ? 'bg-red-500' : 'bg-gray-300'} text-white px-4 py-2 font-medium md:text-sm text-xs`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (!isLoading && otp.join('')) {
                                                verifyOTP(canEmail, otp.join(""));
                                            }
                                        }}
                                    >
                                        {isLoading ? <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto"></div> : Lang(lang, "verify")}
                                    </button>
                                )}
                            </div>

                            {errors.otp && <p className="text-red-500 text-xs mt-1 mb-3">{Lang(lang, errors.otp) || errors.otp}</p>}
                        </div>
                    )}

                    <div className="relative flex items-center border rounded-full overflow-hidden">
                        <input type="email" id="email" className={`rounded-[35px] job-form ${errors.canEmail ? "border-red-500" : "border-[#48494B]"
                            } text-sm p-[16px] pl-[20px] w-full h-[60px] pr-[33%] md:pr-[20%]`} required onChange={(e) => {
                                setCanEmail(e.target.value)
                                setOtp(Array(4).fill(""))
                                setisVerify(false)
                                setCounter(0)
                                const newErrors = {};
                                if (!candName) newErrors.candName = "full_name_required";
                                if (!canPhoneNumber) newErrors.canPhoneNumber = "phone_number_required";
                                if (!e.target.value) newErrors.canEmail = "email_required";
                                setErrors(newErrors);
                            }} />
                        {isVerified ?
                            <img className="w-[25px] absolute right-3 md:right-5" src={"/asset/icon/check_green.svg"} />
                            :
                            <button className={`rounded-full absolute ${canEmail && isValidEmail(canEmail) && canEmail && canPhoneNumber ? 'bg-red-500' : 'bg-gray-300'} text-white px-4 py-1 font-medium right-3 md:text-sm text-xs`} onClick={(e) => {
                                e.preventDefault();
                                if (canEmail && counter === 0 && isValidEmail(canEmail) && canEmail && canPhoneNumber) {
                                    setCounter(120);
                                    sendOTP(candName, canEmail, job.companyID);
                                }
                            }}>
                                {counter > 0
                                    ? `${Math.floor(counter / 60)}:${String(counter % 60).padStart(2, "0")}`
                                    : isVerify ? Lang(lang, "resend") : Lang(lang, "verify")}
                            </button>}
                    </div>
                    {errors.canEmail && <p className="text-red-500 text-xs mt-1">{Lang(lang, errors.canEmail)}</p>}
                </div>
                {isVerified && <div className="mb-4 w-full">
                    <label htmlhtmlFor="email" className="block mb-2 text-xs md:text-[17px] font-medium text-[#48494B]">{Lang(lang, 'password')}<b className='text-[#EA2427] font-semibold'>*</b></label>
                    <div className="relative">
                        <input
                            type={showPassword ? "text" : "password"}
                            id="password"
                            value={password}
                            onChange={(e) => {
                                setpassword(e.target.value)

                                const newErrors = {};
                                if (!canEmail) newErrors.canEmail = "email_required";
                                if (!candName) newErrors.candName = "full_name_required";
                                if (!canPhoneNumber) newErrors.canPhoneNumber = "phone_number_required";
                                if (!e.target.value) newErrors.password = "password_required";
                                if (e.target.value.length < 6) newErrors.password = "password_length";
                                setErrors(newErrors);
                            }}
                            className={`h-[60px] pl-5 pr-4 py-2 border rounded-full w-full h-[43px] text-sm border-[#ffffff]`}
                        />
                        <a href="" onClick={(e) => {
                            e.preventDefault()
                            setshowPassword(!showPassword)
                        }}>
                            <img
                                src={showPassword ? "/asset/icon/eye_close.svg" : "/asset/icon/eye.svg"}
                                alt="show"
                                className="absolute right-3 md:right-5 top-1/2 transform -translate-y-1/2 w-8 h-8 cursor-pointer"
                            /></a>
                    </div>

                    {errors.password && <p className="text-red-500 text-xs mt-1">{Lang(lang, errors.password)}</p>}
                </div>}{isVerified && <div className="mb-4 w-full">
                    <label htmlhtmlFor="email" className="block mb-2 text-xs md:text-[17px] font-medium text-[#48494B]">{Lang(lang, 'confirm_password')}<b className='text-[#EA2427] font-semibold'>*</b></label>
                    <div className="relative">
                        <input
                            type={showConfirmPassword ? "text" : "password"}
                            id="password"
                            value={confirmpassword}
                            onChange={(e) => {
                                setconfirmpassword(e.target.value)
                                const newErrors = {};
                                if (!canEmail) newErrors.canEmail = "email_required";
                                if (!candName) newErrors.candName = "full_name_required";
                                if (!canPhoneNumber) newErrors.canPhoneNumber = "phone_number_required";
                                if (password.length < 6) newErrors.password = "password_length";
                                if (!password) newErrors.password = "password_required";
                                if (password !== e.target.value) newErrors.confirmpassword = 'password_not_match';
                                if (!e.target.value) newErrors.confirmpassword = "password_required";
                                if (`${e.target.value}`.length < 6) newErrors.confirmpassword = "password_length";
                                setErrors(newErrors);
                            }}
                            className={`h-[60px] pl-5 pr-4 py-2 border rounded-full w-full h-[43px] text-sm border-[#ffffff]`}
                        />
                        <a href="" onClick={(e) => {
                            e.preventDefault()
                            setshowConfirmPassword(!showConfirmPassword)

                            const newErrors = {};
                            if (!candName) newErrors.candName = "full_name_required";
                            if (!canPhoneNumber) newErrors.canPhoneNumber = "phone_number_required";
                            if (!e.target.value) newErrors.canEmail = "email_required";
                            setErrors(newErrors);
                        }}>
                            <img
                                src={showPassword ? "/asset/icon/eye_close.svg" : "/asset/icon/eye.svg"}
                                alt="show"
                                className="absolute right-3 md:right-5 top-1/2 transform -translate-y-1/2 w-8 h-8 cursor-pointer"
                            /></a>
                    </div>

                    {errors.confirmpassword && <p className="text-red-500 text-xs mt-1">{Lang(lang, errors.confirmpassword)}</p>}
                </div>}
                {isSending ?
                    <div className='mb-2 mt-12 bg-[#EA2427] text-white font-semibold text-sm md:text-base rounded-full py-2 px-6 w-fit w-[80px]' onClick={() => {
                    }}>
                        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto" />
                    </div> :
                    <div className='mb-2 mt-12' onClick={() => {
                        if (!isSending) {
                            handleSubmit();
                        }
                    }}>
                        <a href='#' onClick={(e) => {
                            e.preventDefault();
                        }} className="bg-[#EA2427] text-white font-semibold text-sm md:text-base rounded-full py-2 px-6">{'Submit'}</a>
                    </div>
                }


                <label htmlFor="message" className="block text-xs md:text-[12px] mt-5 font-medium text-[#48494B]">{Lang(lang, 'already_have_an_account')}<a href="" className="ml-3 font-bold text-[#EA2427] underline text-[14px]" onClick={(e) => {
                    e.preventDefault()
                    setIsDrawerOpen(false)
                    startTransition(`/${lang}/login`);
                }}>Login</a></label>

            </form>
        </Drawer>
    </>)
}

export default JobDrawer;
